// app/store.js
import { configureStore } from "@reduxjs/toolkit";
import userListReducer from "./slices/userSlice";
import pointsReducer from "./slices/pointSlice";
import accessManagerReducer from "./slices/accessManagerSlice";
import panelReducer from "./slices/panelSlice";
import pageAndVariable from "./slices/panelSlice/pageAndVariableSlice";
import language from "./slices/panelSlice/languageSlice";
import option from "./slices/LocationSlice/optionSlice";
import pageHeader from "./slices/panelSlice/pageHeaderSlice";
import variableList from "./slices/panelSlice/variableListSlice";
import countryList from "./slices/LocationSlice/countrySlice";
import genderList from "./slices/genderSlice";
import state from "./slices/LocationSlice/stateSlice";
import region from "./slices/LocationSlice/regionSlice";
import division from "./slices/LocationSlice/divisionSlice";
import pincode from "./slices/LocationSlice/pincodeSlice";
import district from "./slices/LocationSlice/districtSlice";
import block from "./slices/LocationSlice/blockSlice";
import area from "./slices/LocationSlice/areaSlice";
import subCategory from "./slices/LocationSlice/subCategorySlice";
import locationMap from "./slices/LocationSlice/locationMapSlice";
import smsBox from "./slices/messageBoxSlice";
import panelUser from "./slices/panelUserSlice";
import mailBox from "./slices/mailBoxSlice";
import helpSupportQuery from "./slices/helpSupportQuerySlice";
import helpSupportOpenQuery from "./slices/helpSupportOpenSlice"
import helpSupportHelp from "./slices/helpSupportHelpSlice";
import reward from "./slices/TransactionHistorySlice/RewardSlice";
import rewardType from "./slices/TransactionHistorySlice/RewardTypeSlice";
import surveyStatus from "./slices/TransactionHistorySlice/SurveyStatusSlice";
import transaction from "./slices/TransactionHistorySlice/TransactionSlice";
import transactionType from "./slices/TransactionHistorySlice/TransactionTypeSlice";
import agency from "./slices/RedeemSlice/AgencySlice";
import map from "./slices/LocationSlice/mapSlice";
import tier from "./slices/LocationSlice/tierSlice";
import city from "./slices/LocationSlice/citySlice";
import tierMapper from "./slices/LocationSlice/tierMapSlice";
import userBioList from "./slices/userBioSlice";

import sourceList from './slices/jointSourceSlice/JointSourceSlice';
import userDonationSlice from "./slices/RedeemSlice/userDonationSlice";
import notificationReducer from "./slices/notificationSlice/NotificationSlice";
import ReferralSlice from './slices/referralSlice/ReferralSlice';

import AccessAppCategorySlice from './slices/accessManager/AccessAppCategorySlice';
import AccessAppSubCategorySlice from "./slices/accessManager/AccessAppSubCategorySlice";
import AccessAppProjectEndPointSlice from "./slices/accessManager/AccessAppProjectEndPointSlice";
import AccessProjectRequestSlice from "./slices/accessManager/AccessProjectRequestSlice";
import AccessAppSecuritySlice from './slices/accessManager/AccessAppSecuritySlice';
import AccessProjectSectionSlice from './slices/accessManager/AccessProjectSectionSlice';
import AccessProjectSectionMapSlice from './slices/accessManager/AccessProjectSectionMapSlice'
import AcessprojectSectionFieldSlice from './slices/accessManager/AcessprojectSectionFieldSlice'


const store = configureStore({
  reducer: {
    userList: userListReducer,
    bonusPoint: pointsReducer,
    accessManager: accessManagerReducer,
    panel: panelReducer,
    pageAndVariable,
    language,
    option,
    pageHeader,
    variableList,
    countryList,
    genderList,
    state,
    region,
    division,
    pincode,
    district,
    block,
    area,
    subCategory,
    locationMap,
    smsBox,
    panelUser,
    mailBox,
    helpSupportQuery,
    helpSupportOpenQuery,
    helpSupportHelp,
    reward,
    rewardType,
    surveyStatus,
    transaction,
    transactionType,
    agency,
    map,
    tier,
    city,
    tierMapper,
    userBioList,
    sourceList,
    userDonationList: userDonationSlice,
    notificationData : notificationReducer,
    referralData : ReferralSlice,
  
    
  // Access manager App
   accessAppCategory : AccessAppCategorySlice,
   accesAppSubManager : AccessAppSubCategorySlice,
   accesprojectendPointManager : AccessAppProjectEndPointSlice,
   accesprojectRequest : AccessProjectRequestSlice,
   accessAppSecurity : AccessAppSecuritySlice,
   accesprojectSection : AccessProjectSectionSlice,
   accesprojectSectionMap : AccessProjectSectionMapSlice,
   accesprojectSectionField : AcessprojectSectionFieldSlice
  },
});

export default store;
